module.exports = __webpack_public_path__ + "static/img/6.82c5993.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/6.png
// module id = So+S
// module chunks = 0